import { render, staticRenderFns } from "./PromoTemplateA4.vue?vue&type=template&id=7f1039d8"
import script from "./PromoTemplateA4.vue?vue&type=script&lang=js"
export * from "./PromoTemplateA4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports